export default class ProductNotices {
    constructor(element) {
        this.elementDOM  = element;
        this.productNoticeWrapper = element.html();
        this.productDOM = this.elementDOM.parents(
            ywdpd_qty_args.column_product_info_class
        );
        this.variationForm = this.productDOM.find(
            ywdpd_qty_args.variation_form_class
        );

        if (this.variationForm) {
            this.variationForm.on(
                'show_variation',
                this.showVariationNotices.bind(this)
            );
            this.variationForm.on(
                'reset_data',
                this.resetVariationNotices.bind(this)
            );
        }
    }

    showVariationNotices(event, variation) {
        if( variation.ywdpd_notices){
            const newNoticesWrapper = jQuery(variation.ywdpd_notices);
            if( newNoticesWrapper.length){
                this.elementDOM.html( newNoticesWrapper.html()).show();
            }else{
                this.elementDOM.hide();
            }
        }
    }

    resetVariationNotices(){
        this.elementDOM.html(this.productNoticeWrapper).show()
    }
}